// Vendors
import { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React from 'react';
// Hooks
import { useTokenHook } from './hooks/token.hook';

const TokenProvider = ({ children }: ReactChildrenType): React.ReactNode => {
  useTokenHook();

  return children;
};

export { TokenProvider };
